import Error from '../model/Error';
import MemberClubFee from '../dto/MemberClubFee.js';
import axios from 'axios';

export default class ClubSalesListMemberClubFeeRepository {

    static findByClubIdAndFilters(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/member-club-fees${query}`)
                .then(response => resolve(response.data.data.map(data => MemberClubFee.fromDataAndSalesListContext(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByMemberIdAndFilters(memberId, query, fromDummyFrontend) {
        const url = fromDummyFrontend
            ? `/members/${memberId}/sales-list/member-club-fees${query}`
            : `/club/members/${memberId}/sales-list/member-club-fees${query}`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => resolve(response.data.data.map(data => MemberClubFee.fromDataAndSalesListContext(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
